export enum SortOrder { ASC = 1, DESC };

export enum ActivityType {
  Buy = 'Buy',
  Sell = 'Sell',
  Dividend = 'Dividend',
  Distribution = 'Distribution',
  Interest = 'Interest',
  ReturnOfCapital = 'ReturnOfCapital',
  Reorganization = 'Reorganization',
  Contribution = 'Contribution',
  Withdrawal = 'Withdrawal',
  Transfers = 'Transfers',
  Fees = 'Fees',
  Taxes = 'Taxes',
  Unknown = 'Unknown'
};

export enum CurrencyCode {
  CAD = 'CAD',
  USD = 'USD'
};

export enum SecurityType {
  FixedIncome = 'FixedIncome',
  MutualFund = 'MutualFund',
  CommonShare = 'CommonShare',
  PreferredShare = 'PreferredShare',
  Option = 'Option',
  Unknown = 'Unknown'
};

export enum SecurityCategory {
  Equity = 'Equity',
  Option = 'Option',
  MutualFund = 'MutualFund',
  FixedIncome = 'FixedIncome',
  Other = 'Other'
};

export enum OrderType {
  MarketPrice = 'MarketPrice',
  LimitPrice = 'LimitPrice',
  StopPrice = 'StopPrice',
  StopLimit = 'StopLimit',
  MFUnitAmount = 'MFUnitAmount',
  MFDollarAmount = 'MFDollarAmount',
  MFAllUnits ='MFAllUnits',
  Unknown = 'Unknown'
};

export enum SubmittedStatus {
  Pending = 'pending',
  Queued = 'queued',
  Booked = 'booked',
  Received = 'received',
  Rejected_se = 'rejected_se',
  Rejected_if = 'rejected_if',
  Rejected = 'rejected',
  Processed = 'processed',
  Completed = 'completed',
  Killed = 'killed',
  Cancelled = 'cancelled',
  Unavailable = 'unavailable'
};

export const reduceStatus = (status: SubmittedStatus): SubmittedStatus => {
  if ([SubmittedStatus.Queued, SubmittedStatus.Booked].includes(status)) {
    return SubmittedStatus.Received;
  }
  if ([SubmittedStatus.Rejected_se, SubmittedStatus.Rejected_if].includes(status)) {
    return SubmittedStatus.Rejected;
  }
  if (status === SubmittedStatus.Processed) {
    return SubmittedStatus.Completed;
  }
  if (status === SubmittedStatus.Killed) {
    return SubmittedStatus.Cancelled;
  }
  return status;
};

export enum OrderStatus {
  Undefined = 'Undefined',
  Received = 'Received',
  Pending = 'Pending',
  Open = 'Open',
  Expired = 'Expired',
  Rejected = 'Rejected',
  Filled = 'Filled',
  PartFilled = 'PartFilled',
  ModifyPending = 'ModifyPending',
  ModifySubmitted = 'ModifySubmitted',
  ModifyRejected = 'ModifyRejected',
  CancelSubmitted = 'CancelSubmitted',
  CancelModify = 'CancelModify',
  CancelModifySubmitted = 'CancelModifySubmitted'
};

export enum EquityModal {
  BuyingMargin = 'BuyingMargin',
  OrderType = 'OrderType',
  PayWithPoints = 'PayWithPoints',
  OrderDuration = 'OrderDuration',
  ImportantEquityA1 = 'ImportantEquityA1',
  ImportantEquityA2 = 'ImportantEquityA2',
  ImportantEquityB1 = 'ImportantEquityB1',
  PositionHeld = 'PositionHeld',
  ExtendedHrsPM = 'ExtendedHrsPM',
  ExtendedHrsAH = 'ExtendedHrsAH',
  PreMarketTrading = 'PreMarketTrading',
  PostMarketTrading = 'PostMarketTrading',
  GemSecurityRisk = 'GemSecurityRisk',
  GlobalTradingFees = 'GlobalTradingFees',
};

export enum HSBCStatus {
  Unknown = 'Unknown',
  RBCClient = 'RBCClient',
  HSBCClient = 'HSBCClient',
  RBCandHSBCClient = 'RBCandHSBCClient'
};

export enum ExchangeAgreementEnum {
  UNKNOWN = 'UNKNOWN',
  CEG = 'CEG',
  ME = 'ME',
  NASDAQ = 'NASDAQ',
  NYSE = 'NYSE',
  OPRA = 'OPRA',
  AMEX = 'AMEX',
  HKG ='HKG'
};

export enum NASDAQSubscriber {
  UNKNOWN = 'UNKNOWN',
  Individual = 'Individual',
  Firm = 'Firm'
};

export enum NASDAQStatus {
  UNKNOWN = 'UNKNOWN',
  US = 'US',
  NonUS = 'NonUS',
};

export enum EmeraldPhase {
  PreT70,
  T70,
  T0
};

export enum TourKind {
  Featured = 'featured', 
  Trade = 'trade',
  TradeHK = 'tradehk',
  AccountManagement = 'accountmanagement',
  InvestingPreferences = 'investingpreferences',
  Research = 'research',
  IncomeProjection = 'incomeprojection',
}

export enum RepaperingPhase {
  Inactive,
  PreTranche,
  TrancheActive,
  TrancheEndApproach,
  TrancheEndAlmostUp,
  Completed
}

export namespace Repapering {
  export enum AccountRelationshipType {
    UNKNOWN = "UNKNOWN",
    PRIMARY_APPLICANT = "PRIMARY_APPLICANT",
    CO_APPLICANT = "CO_APPLICANT",
    CO_APPLICANT_2 = "CO_APPLICANT_2",
    ADDITIONAL_APPLICANT = "ADDITIONAL_APPLICANT",
    TRADING_AUTHORITY = "TRADING_AUTHORITY",
    THIRD_PARTY = "THIRD_PARTY",
    POWER_OF_ATTORNEY = "POWER_OF_ATTORNEY",
  }
  export enum MaritalStatus {
    SINGLE = "SINGLE",
    MARRIED = "MARRIED",
    DIVORCED = "DIVORCED",
    COMMONLAW = "COMMONLAW",
    UNKNOWN = "UNKNOWN",
  }
  export enum Language {
    English = "English",
    French = "French",
    Unknown = "Unknown"
  }
  export enum AccountType {
    Cash = "Cash",
    Margin = "Margin"
  }
  export enum AccountPurposeDetail
  {
    UNKNOWN = "UNKNOWN",
    RSP = "RSP",
    RSP_SPOUSAL = "RSP_SPOUSAL",
    RSP_GROUP = "RSP_GROUP",
    RSP_GROUP_SPOUSAL = "RSP_GROUP_SPOUSAL",
    LIRA = "LIRA",
    RLSP = "RLSP",
    RIF = "RIF",
    RIF_SPOUSAL = "RIF_SPOUSAL",
    LRIF = "LRIF",
    LIF = "LIF",
    RLIF = "RLIF",
    PRIF = "PRIF",
    RESP_INDIVIDUAL = "RESP_INDIVIDUAL",
    RESP_FAMILY = "RESP_FAMILY",
    TFSA = "TFSA",
    TFSA_GROUP = "TFSA_GROUP",
    TFSA_RESTRICTED_GROUP = "TFSA_RESTRICTED_GROUP",
    RESP_JOINT = "RESP_JOINT",
    RESP_JOINT_FAMILY = "RESP_JOINT_FAMILY",
    INVESTMENT = "INVESTMENT",
    COLLATERAL_PLEDGE = "COLLATERAL_PLEDGE",
    INVESTMENT_3RD_APP = "INVESTMENT_3RD_APP",
    INVESTMENT_GROUP = "INVESTMENT_GROUP",
    COLLATERAL_PLEDGE_JOINT = "COLLATERAL_PLEDGE_JOINT",
    COLLATERAL_PLEDGE_3RD_APP = "COLLATERAL_PLEDGE_3RD_APP",
    INFORMAL_TRUST_JOINT = "INFORMAL_TRUST_JOINT",
    INFORMAL_TRUST = "INFORMAL_TRUST",
    FORMAL_TRUST = "FORMAL_TRUST",
    INVESTMENT_CONTROL = "INVESTMENT_CONTROL",
    INVESTMENT_JOINT = "INVESTMENT_JOINT"
  }
  export enum PhysicalMail
  {
    NO = "NO",
    YESALL = "YESALL",
    YESPROXY = "YESPROXY",
    UNKNOWN = "UNKNOWN"
  }
  export enum PensionLegislation
  {
    None = "None",
    FEDERAL = "FEDERAL",
    AB = "AB",
    BC = "BC",
    MB = "MB",
    NB = "NB",
    NL = "NL",
    NT = "NT",
    NS = "NS",
    NU = "NU",
    ON = "ON",
    PE = "PE",
    QC = "QC",
    SK = "SK",
    YT = "YT",
    FN = "FN",
    NO = "NO",
    PQ = "PQ",
    FD = "FD"
  }
  export enum FormID
  {
    Unknown = "Unknown",
    CLIENT_PROFILE = "CLIENT_PROFILE",
    RRSP = "RRSP",
    COI_OAA = "COI_OAA",
    DT_RSP = "DT_RSP",
    DT_RIF = "DT_RIF",
    OPTIONS_TR_MARGIN = "OPTIONS_TR_MARGIN",
    MARGIN = "MARGIN",
    PERS_GUAR = "PERS_GUAR",
    PERS_GUAR_QC = "PERS_GUAR_QC",
    CORP_RES_MARGIN = "CORP_RES_MARGIN",
    NAKED_PUT = "NAKED_PUT",
    NAKED_PUT_QC = "NAKED_PUT_QC",
    CORP_RES_OPTION = "CORP_RES_OPTION",
    TA = "TA",
    TA_SUPPL = "TA_SUPPL",
    TFSA = "TFSA",
    W8BEN = "W8BEN",
    W9 = "W9",
    RC520 = "RC520",
    INV_SOLE = "INV_SOLE",
    INV_JOINT = "INV_JOINT",
    INV_JOINT_3_4 = "INV_JOINT_3_4",
    COAPP_PROFILE = "COAPP_PROFILE",
    THIRD_PARTY_DET = "THIRD_PARTY_DET",
    CO_MINGLING = "CO_MINGLING",
    RRIF = "RRIF",
    LIRA = "LIRA",
    RESP = "RESP",
    CESG = "CESG",
    CA_LEARN_BOND = "CA_LEARN_BOND",
    ANNEX_B_CG = "ANNEX_B_CG",
    LRIF = "LRIF",
    LRIF_ADD = "LRIF_ADD",
    SP_CONSENT = "SP_CONSENT",
    LIF = "LIF",
    PRIF = "PRIF",
    RLIF = "RLIF",
    RLSP = "RLSP",
    RESP_FAMILY = "RESP_FAMILY",
    SP_CONSENT_MB = "SP_CONSENT_MB",
    SP_CONSENT_SK = "SP_CONSENT_SK",
    LIA_LIF_AB = "LIA_LIF_AB",
    LIA_LIF_FED = "LIA_LIF_FED",
    LIA_LIF_MB = "LIA_LIF_MB",
    LIA_LIF_NB = "LIA_LIF_NB",
    LIA_LIF_NL = "LIA_LIF_NL",
    LIA_LIF_NS = "LIA_LIF_NS",
    LIA_LIF_ON = "LIA_LIF_ON",
    LIA_LIF_QC = "LIA_LIF_QC",
    LIA_LIRA_AB = "LIA_LIRA_AB",
    LIA_LIRA_BC = "LIA_LIRA_BC",
    LIA_LIRA_MB = "LIA_LIRA_MB",
    LIA_LIRA_NB = "LIA_LIRA_NB",
    LIA_LIRA_NL = "LIA_LIRA_NL",
    LIA_LIRA_NS = "LIA_LIRA_NS",
    LIA_LIRA_ON = "LIA_LIRA_ON",
    LIA_LIRA_QC = "LIA_LIRA_QC",
    LIA_LIRA_SK = "LIA_LIRA_SK",
    LIA_LRIF_NL = "LIA_LRIF_NL",
    LIA_LRSP_FED = "LIA_LRSP_FED",
    LIA_PRIF_MB = "LIA_PRIF_MB",
    LIA_PRIF_SK = "LIA_PRIF_SK",
    LIA_RIF_BC = "LIA_RIF_BC",
    LIA_RLIF_FED = "LIA_RLIF_FED",
    LIA_RLSP_FED = "LIA_RLSP_FED",
    SP_CONSENT_AB_FORM10 = "SP_CONSENT_AB_FORM10",
    SP_CONSENT_AB_FORM15 = "SP_CONSENT_AB_FORM15",
    SP_CONSENT_ON = "SP_CONSENT_ON",
    SP_CONSENT_BC = "SP_CONSENT_BC",
    SP_CONSENT_NL = "SP_CONSENT_NL",
    SP_CONSENT_LIF_MB = "SP_CONSENT_LIF_MB",
    SP_CONSENT_NS = "SP_CONSENT_NS",
    LIA_LIF_BC = "LIA_LIF_BC",
    EDELIVERY_CONSENT = "EDELIVERY_CONSENT",
    TRUST_AGRMT_TFSA = "TRUST_AGRMT_TFSA",
    PLAN_TEXT_RESP_FAMILY = "PLAN_TEXT_RESP_FAMILY",
    INFORMAL_TRUST = "INFORMAL_TRUST"
  }
  export enum FormType
  {
    DIGITAL = "DIGITAL",
    DIGITAL2MAIL = "DIGITAL2MAIL",
    PAPER = "PAPER",
    STATIC = "STATIC"
  }
  export enum FormStatus {
    INCOMPLETE = "incomplete",
    RECEIVED = "received",
    ACTION_REQUIRED = "action_required",
    APPROVED = "approved",
  };  
}